module.exports = __webpack_public_path__ + "static/media/img6.8ebb7c38.jpg";